import { motion } from "framer-motion";

// Masked line-by-line / word reveal used across the site.
export function Reveal({ text, className = "", delay = 0, once = true }) {
  const words = String(text).split(" ");
  return (
    <span className={className} style={{ display: "inline" }}>
      {words.map((w, i) => (
        <span key={i} className="reveal-line" style={{ display: "inline-block", verticalAlign: "top" }}>
          <motion.span
            style={{ display: "inline-block" }}
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once, margin: "-10% 0px" }}
            transition={{ duration: 0.9, delay: delay + i * 0.045, ease: [0.16, 1, 0.3, 1] }}
          >
            {w}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-12% 0px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

// Section label with animated hairline
export function SectionLabel({ index, children, id }) {
  return (
    <motion.div
      id={id}
      className="flex items-center gap-4 mb-10 md:mb-16"
      {...fadeUp}
      data-testid={id ? `label-${id}` : undefined}
    >
      <span className="track-label text-[color:var(--silver)]">{index}</span>
      <span className="h-px flex-1 max-w-[80px] bg-white/15" />
      <span className="track-label text-white/70">{children}</span>
    </motion.div>
  );
}
